import { useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { Button } from 'antd'
import { FrownOutlined } from '@ant-design/icons'
import BupLogo from '@BUP/assets/Images/bup_logo1.png'
import styles from './error_message.module.scss'
import ButtonComponent from '@BUP/components/Generics/Buttons/button-component'
import { useSignOut } from '@BUP/services/auth/use-sign-out'

const ErrorMessage = ({ message, withSignOut }) => {
  const i18n = useTranslation()
  const navigate = useNavigate()

  const { mutate: handleOnClickSignOut, loading: signOutLoading, error: signOutError } = useSignOut()

  if (signOutLoading) {
    return (
      <div className={styles.loading_container}>
        <p>{i18n.t('common.resources.session.actions.destroy.loading')}</p>
      </div>
    )
  }

  if (signOutError) {
    return (
      <p>
        {i18n.t('common.resources.session.actions.destroy.failure', {
          context: 'with-message',
          message: signOutError.message
        })}
      </p>
    )
  }

  const reloadPage = () => {
    navigate('/')
    window.location.reload()
  }

  return (
    <div className={styles.container}>
      <img src={BupLogo} alt='no logo' />
      <div className={styles.error_message_container}>
        <div className={styles.icon_wrapper}>
          <FrownOutlined />
        </div>
        <div className={styles.text_wrapper}>
          <h2>{message || i18n.t('nav.error.errorMessage')}</h2>
        </div>
        <div className={styles.button_wrapper}>
          {withSignOut
            ? (
              <ButtonComponent
                buttonText={i18n.t('common.resources.session.actions.destroy.submit')}
                onClick={handleOnClickSignOut}
              />
              )
            : (
              <Button
                type='primary'
                shape='round'
                size='large'
                onClick={() => reloadPage()}
              >
                {i18n.t('nav.error.buttonError')}
              </Button>
              )}
        </div>
      </div>
    </div>
  )
}

export default ErrorMessage
